var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { arrow, autoUpdate, computePosition, flip, offset, shift, size } from "@floating-ui/dom";
var ARROW_SIZE = 8;
export function useTooltipOptions(tooltip, options) {
    if (options === void 0) { options = {}; }
    options = __assign({ placement: 'bottom', middleware: [
            shift({
                mainAxis: true,
                padding: 16,
            }),
            size(),
            flip(),
            offset(8),
        ] }, options);
    var arrowEl = tooltip.querySelector('[data-arrow]');
    if (arrowEl) {
        options.middleware.push(arrow({ element: arrowEl }));
    }
    return options;
}
var registry = [];
var closeClickHandlerAdded = false;
function addCloseClickHandler() {
    if (closeClickHandlerAdded) {
        return;
    }
    document.addEventListener('click', function (e) {
        var e_1, _a;
        try {
            for (var _b = __values(registry.filter(function (tooltip) { return tooltip.shown; })), _c = _b.next(); !_c.done; _c = _b.next()) {
                var tooltip = _c.value;
                if (tooltip.element.contains(e.target) || !tooltip.tooltip.contains(e.target)) {
                    tooltip.hide();
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    });
}
function closeAllShownTooltips() {
    var e_2, _a;
    try {
        for (var _b = __values(registry.filter(function (tooltip) { return tooltip.shown; })), _c = _b.next(); !_c.done; _c = _b.next()) {
            var tooltip = _c.value;
            tooltip.hide();
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
var Tooltip = /** @class */ (function () {
    function Tooltip(element, tooltip, options) {
        if (options === void 0) { options = {}; }
        this.element = element;
        this.tooltip = tooltip;
        this.options = useTooltipOptions(tooltip, options);
        this.arrowElement = this.tooltip.querySelector('[data-arrow]');
    }
    Tooltip.prototype.attachClickEvents = function () {
        registry.push(this);
        addCloseClickHandler();
        this.element.addEventListener('click', this.onclick.bind(this));
    };
    Tooltip.prototype.attachHoverEvents = function () {
        this.element.addEventListener('mouseenter', this.show.bind(this));
        this.element.addEventListener('mouseleave', this.hide.bind(this));
    };
    Tooltip.prototype.destroy = function () {
        var _this = this;
        this.element.removeEventListener('click', this.onclick.bind(this));
        this.element.removeEventListener('mouseenter', this.show.bind(this));
        this.element.removeEventListener('mouseleave', this.hide.bind(this));
        var index = registry.findIndex(function (tooltip) { return tooltip === _this; });
        if (index !== -1) {
            delete registry[index];
        }
    };
    Object.defineProperty(Tooltip.prototype, "shown", {
        get: function () {
            return !!this.cleanup;
        },
        enumerable: false,
        configurable: true
    });
    Tooltip.prototype.show = function () {
        var _this = this;
        closeAllShownTooltips();
        this.tooltip.style.display = 'block';
        this.cleanup = autoUpdate(document.documentElement, this.tooltip, function () {
            computePosition(_this.element, _this.tooltip, _this.options)
                .then(function (_a) {
                var _b;
                var x = _a.x, y = _a.y, placement = _a.placement, middlewareData = _a.middlewareData;
                var placementSide = placement.split('-')[0];
                _this.tooltip.style.left = "".concat(x, "px");
                _this.tooltip.style.top = "".concat(y, "px");
                if (!_this.arrowElement || !middlewareData.arrow) {
                    return;
                }
                var _c = middlewareData.arrow, arrowX = _c.x, arrowY = _c.y;
                var staticSide = {
                    top: 'bottom',
                    right: 'left',
                    bottom: 'top',
                    left: 'right',
                }[placementSide];
                Object.assign(_this.arrowElement.style, (_b = {
                        left: arrowX != null ? "".concat(arrowX, "px") : '',
                        top: arrowY != null ? "".concat(arrowY, "px") : '',
                        right: '',
                        bottom: ''
                    },
                    _b[staticSide] = "-".concat(ARROW_SIZE / 2, "px"),
                    _b.transform = placementSide === 'top' ? 'rotate(180deg)' : '',
                    _b));
            });
        }, { animationFrame: true });
    };
    Tooltip.prototype.hide = function () {
        this.tooltip.style.display = '';
        if (this.cleanup) {
            this.cleanup();
            this.cleanup = null;
        }
    };
    Tooltip.prototype.toggle = function () {
        if (this.shown) {
            this.hide();
        }
        else {
            this.show();
        }
    };
    Tooltip.prototype.onclick = function (event) {
        event.stopPropagation();
        event.preventDefault();
        this.toggle();
    };
    return Tooltip;
}());
export { Tooltip };
var hintSelector = '.help-box';
var hintTooltipSelector = '.help-box__hint';
var tooltipButtonSelector = '.tooltip-btn';
var tooltipSelector = '.tooltip';
export default function initTooltips() {
    document.querySelectorAll(hintSelector)
        .forEach(function (element) {
        new Tooltip(element, element.querySelector(hintTooltipSelector)).attachHoverEvents();
    });
    document.querySelectorAll(tooltipButtonSelector)
        .forEach(function (trigger) {
        new Tooltip(trigger, trigger.parentElement.querySelector(tooltipSelector)).attachClickEvents();
    });
}
